import type { ReactNode } from "react";
import "./CreateTemplateButton.scss";
import useScheduleViewStateDispatch from "@/pages/human-resources/time-management/model/schedule-view/useScheduleViewStateDispatch.ts";

export default function CreateTemplateButton(): ReactNode {
  const { callback } = useScheduleViewStateDispatch();
  return (
    <div
      className="create-template-button"
      onClick={callback({
        type: "setScheduleTemplateCreatorOpen",
        open: true,
      })}
    >
      <div className={"icon"} />
    </div>
  );
}
